/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * bundle.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import.
 */
import { modules } from "./module/modules";
import smoothscroll from "smoothscroll-polyfill";

/**
 * 再読み込み後ページ最上部へ
 */
window.onunload = function () {
  window.scrollTo(0, 0);
}

/**
 * Run.
 */
modules();
smoothscroll.polyfill();

/**
 * Clear console.
 */
// console.clear();